const massPayCountries = [
  {
    code: 'AB',
    name: 'Abkhazia',
    three_letter_code: 'ABK',
  },
  {
    code: 'AF',
    name: 'Afghanistan',
    three_letter_code: 'AFG',
  },
  {
    code: 'AL',
    name: 'Albania',
    three_letter_code: 'ALB',
  },
  {
    code: 'DZ',
    name: 'Algeria',
    three_letter_code: 'DZA',
  },
  {
    code: 'AS',
    name: 'American Samoa',
    three_letter_code: 'ASM',
  },
  {
    code: 'AD',
    name: 'Andorra',
    three_letter_code: 'AND',
  },
  {
    code: 'AO',
    name: 'Angola',
    three_letter_code: 'AGO',
  },
  {
    code: 'AI',
    name: 'Anguilla',
    three_letter_code: 'AIA',
  },
  {
    code: 'AQ',
    name: 'Antarctica',
    three_letter_code: 'ATA',
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
    three_letter_code: 'ATG',
  },
  {
    code: 'AR',
    name: 'Argentina',
    three_letter_code: 'ARG',
  },
  {
    code: 'AM',
    name: 'Armenia',
    three_letter_code: 'ARM',
  },
  {
    code: 'AW',
    name: 'Aruba',
    three_letter_code: 'ABW',
  },
  {
    code: 'AU',
    name: 'Australia',
    three_letter_code: 'AUS',
  },
  {
    code: 'AT',
    name: 'Austria',
    three_letter_code: 'AUT',
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
    three_letter_code: 'AZE',
  },
  {
    code: 'BS',
    name: 'Bahamas',
    three_letter_code: 'BHS',
  },
  {
    code: 'BH',
    name: 'Bahrain',
    three_letter_code: 'BHR',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    three_letter_code: 'BGD',
  },
  {
    code: 'BB',
    name: 'Barbados',
    three_letter_code: 'BRB',
  },
  {
    code: 'BY',
    name: 'Belarus',
    three_letter_code: 'BLR',
  },
  {
    code: 'BE',
    name: 'Belgium',
    three_letter_code: 'BEL',
  },
  {
    code: 'BZ',
    name: 'Belize',
    three_letter_code: 'BLZ',
  },
  {
    code: 'BJ',
    name: 'Benin',
    three_letter_code: 'BEN',
  },
  {
    code: 'BM',
    name: 'Bermuda',
    three_letter_code: 'BMU',
  },
  {
    code: 'BT',
    name: 'Bhutan',
    three_letter_code: 'BTN',
  },
  {
    code: 'BO',
    name: 'Bolivia',
    three_letter_code: 'BOL',
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
    three_letter_code: 'BIH',
  },
  {
    code: 'BW',
    name: 'Botswana',
    three_letter_code: 'BWA',
  },
  {
    code: 'BR',
    name: 'Brazil',
    three_letter_code: 'BRA',
  },
  {
    code: 'IO',
    name: 'British Indian Ocean Territory',
    three_letter_code: 'IOT',
  },
  {
    code: 'VG',
    name: 'British Virgin Islands',
    three_letter_code: 'VGB',
  },
  {
    code: 'BN',
    name: 'Brunei',
    three_letter_code: 'BRN',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
    three_letter_code: 'BGR',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
    three_letter_code: 'BFA',
  },
  {
    code: 'BI',
    name: 'Burundi',
    three_letter_code: 'BDI',
  },
  {
    code: 'KH',
    name: 'Cambodia',
    three_letter_code: 'KHM',
  },
  {
    code: 'CM',
    name: 'Cameroon',
    three_letter_code: 'CMR',
  },
  {
    code: 'CA',
    name: 'Canada',
    three_letter_code: 'CAN',
  },
  {
    code: 'CV',
    name: 'Cape Verde',
    three_letter_code: 'CPV',
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
    three_letter_code: 'CYM',
  },
  {
    code: 'TD',
    name: 'Chad',
    three_letter_code: 'TCD',
  },
  {
    code: 'CL',
    name: 'Chile',
    three_letter_code: 'CHL',
  },
  {
    code: 'CN',
    name: 'China',
    three_letter_code: 'CHN',
  },
  {
    code: 'CX',
    name: 'Christmas Island',
    three_letter_code: 'CXR',
  },
  {
    code: 'CC',
    name: 'Cocos (Keeling) Islands',
    three_letter_code: 'CCK',
  },
  {
    code: 'CO',
    name: 'Colombia',
    three_letter_code: 'COL',
  },
  {
    code: 'KM',
    name: 'Comoros',
    three_letter_code: 'COM',
  },
  {
    code: 'CG',
    name: 'Congo',
    three_letter_code: 'COG',
  },
  {
    code: 'CK',
    name: 'Cook Islands',
    three_letter_code: 'COK',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
    three_letter_code: 'CRI',
  },
  {
    code: 'CI',
    name: 'Côte d’Ivoire',
    three_letter_code: 'CIV',
  },
  {
    code: 'HR',
    name: 'Croatia',
    three_letter_code: 'HRV',
  },
  {
    code: 'CU',
    name: 'Cuba',
    three_letter_code: 'CUB',
  },
  {
    code: 'CW',
    name: 'Curacao',
    three_letter_code: 'CUW',
  },
  {
    code: 'CY',
    name: 'Cyprus',
    three_letter_code: 'CYP',
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
    three_letter_code: 'CZE',
  },
  {
    code: 'CD',
    name: 'Democratic Republic of The Congo',
    three_letter_code: 'COD',
  },
  {
    code: 'DK',
    name: 'Denmark',
    three_letter_code: 'DNK',
  },
  {
    code: 'DJ',
    name: 'Djibouti',
    three_letter_code: 'DJI',
  },
  {
    code: 'DM',
    name: 'Dominica',
    three_letter_code: 'DMA',
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
    three_letter_code: 'DOM',
  },
  {
    code: 'EC',
    name: 'Ecuador',
    three_letter_code: 'ECU',
  },
  {
    code: 'EG',
    name: 'Egypt',
    three_letter_code: 'EGY',
  },
  {
    code: 'SV',
    name: 'El Salvador',
    three_letter_code: 'SLV',
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
    three_letter_code: 'GNQ',
  },
  {
    code: 'ER',
    name: 'Eritrea',
    three_letter_code: 'ERI',
  },
  {
    code: 'EE',
    name: 'Estonia',
    three_letter_code: 'EST',
  },
  {
    code: 'ET',
    name: 'Ethiopia',
    three_letter_code: 'ETH',
  },
  {
    code: 'FK',
    name: 'Falkland Islands (Islas Malvinas)',
    three_letter_code: 'FLK',
  },
  {
    code: 'FO',
    name: 'Faroe Islands',
    three_letter_code: 'FRO',
  },
  {
    code: 'FJ',
    name: 'Fiji',
    three_letter_code: 'FJI',
  },
  {
    code: 'FI',
    name: 'Finland',
    three_letter_code: 'FIN',
  },
  {
    code: 'FR',
    name: 'France',
    three_letter_code: 'FRA',
  },
  {
    code: 'GF',
    name: 'French Guiana',
    three_letter_code: 'GUF',
  },
  {
    code: 'PF',
    name: 'French Polynesia',
    three_letter_code: 'PYF',
  },
  {
    code: 'GA',
    name: 'Gabon',
    three_letter_code: 'GAB',
  },
  {
    code: 'GM',
    name: 'Gambia',
    three_letter_code: 'GMB',
  },
  {
    code: 'GE',
    name: 'Georgia',
    three_letter_code: 'GEO',
  },
  {
    code: 'DE',
    name: 'Germany',
    three_letter_code: 'DEU',
  },
  {
    code: 'GH',
    name: 'Ghana',
    three_letter_code: 'GHA',
  },
  {
    code: 'GI',
    name: 'Gibraltar',
    three_letter_code: 'GIB',
  },
  {
    code: 'GR',
    name: 'Greece',
    three_letter_code: 'GRC',
  },
  {
    code: 'GL',
    name: 'Greenland',
    three_letter_code: 'GRL',
  },
  {
    code: 'GD',
    name: 'Grenada',
    three_letter_code: 'GRD',
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
    three_letter_code: 'GLP',
  },
  {
    code: 'GU',
    name: 'Guam',
    three_letter_code: 'GUM',
  },
  {
    code: 'GT',
    name: 'Guatemala',
    three_letter_code: 'GTM',
  },
  {
    code: 'GG',
    name: 'Guernsey, Channel Islands',
    three_letter_code: 'GSY',
  },
  {
    code: 'GN',
    name: 'Guinea',
    three_letter_code: 'GIN',
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
    three_letter_code: 'GNB',
  },
  {
    code: 'GY',
    name: 'Guyana',
    three_letter_code: 'GUY',
  },
  {
    code: 'HT',
    name: 'Haiti',
    three_letter_code: 'HTI',
  },
  {
    code: 'HN',
    name: 'Honduras',
    three_letter_code: 'HND',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
    three_letter_code: 'HKG',
  },
  {
    code: 'HU',
    name: 'Hungary',
    three_letter_code: 'HUN',
  },
  {
    code: 'IS',
    name: 'Iceland',
    three_letter_code: 'ISL',
  },
  {
    code: 'IN',
    name: 'India',
    three_letter_code: 'IND',
  },
  {
    code: 'ID',
    name: 'Indonesia',
    three_letter_code: 'IDN',
  },
  {
    code: 'IE',
    name: 'Ireland',
    three_letter_code: 'IRL',
  },
  {
    code: 'IM',
    name: 'Isle of Man',
    three_letter_code: 'IMN',
  },
  {
    code: 'IL',
    name: 'Israel',
    three_letter_code: 'ISR',
  },
  {
    code: 'IT',
    name: 'Italy',
    three_letter_code: 'ITA',
  },
  {
    code: 'JM',
    name: 'Jamaica',
    three_letter_code: 'JAM',
  },
  {
    code: 'SJ',
    name: 'Jan Mayen',
    three_letter_code: 'SJM',
  },
  {
    code: 'JP',
    name: 'Japan',
    three_letter_code: 'JPN',
  },
  {
    code: 'JE',
    name: 'Jersey',
    three_letter_code: 'JEY',
  },
  {
    code: 'JO',
    name: 'Jordan',
    three_letter_code: 'JOR',
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
    three_letter_code: 'KAZ',
  },
  {
    code: 'KE',
    name: 'Kenya',
    three_letter_code: 'KEN',
  },
  {
    code: 'KI',
    name: 'Kiribati',
    three_letter_code: 'KIR',
  },
  {
    code: 'XK',
    name: 'Kosovo',
    three_letter_code: 'XKX',
  },
  {
    code: 'KW',
    name: 'Kuwait',
    three_letter_code: 'KWT',
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
    three_letter_code: 'KGZ',
  },
  {
    code: 'LA',
    name: "Lao People's Democratic Republic",
    three_letter_code: 'LAO',
  },
  {
    code: 'LV',
    name: 'Latvia',
    three_letter_code: 'LVA',
  },
  {
    code: 'LS',
    name: 'Lesotho',
    three_letter_code: 'LSO',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
    three_letter_code: 'LIE',
  },
  {
    code: 'LT',
    name: 'Lithuania',
    three_letter_code: 'LTU',
  },
  {
    code: 'LU',
    name: 'Luxembourg',
    three_letter_code: 'LUX',
  },
  {
    code: 'MO',
    name: 'Macao',
    three_letter_code: 'MAC',
  },
  {
    code: 'MK',
    name: 'Macedonia',
    three_letter_code: 'MKD',
  },
  {
    code: 'MG',
    name: 'Madagascar',
    three_letter_code: 'MDG',
  },
  {
    code: 'MW',
    name: 'Malawi',
    three_letter_code: 'MWI',
  },
  {
    code: 'MY',
    name: 'Malaysia',
    three_letter_code: 'MYS',
  },
  {
    code: 'MV',
    name: 'Maldives',
    three_letter_code: 'MDV',
  },
  {
    code: 'ML',
    name: 'Mali',
    three_letter_code: 'MLI',
  },
  {
    code: 'MT',
    name: 'Malta',
    three_letter_code: 'MLT',
  },
  {
    code: 'MH',
    name: 'Marshall Islands',
    three_letter_code: 'MHL',
  },
  {
    code: 'MQ',
    name: 'Martinique',
    three_letter_code: 'MTQ',
  },
  {
    code: 'MR',
    name: 'Mauritania',
    three_letter_code: 'MRT',
  },
  {
    code: 'MU',
    name: 'Mauritius',
    three_letter_code: 'MUS',
  },
  {
    code: 'YT',
    name: 'Mayotte',
    three_letter_code: 'MYT',
  },
  {
    code: 'MX',
    name: 'Mexico',
    three_letter_code: 'MEX',
  },
  {
    code: 'FM',
    name: 'Micronesia',
    three_letter_code: 'FSM',
  },
  {
    code: 'MD',
    name: 'Moldova',
    three_letter_code: 'MDA',
  },
  {
    code: 'MC',
    name: 'Monaco',
    three_letter_code: 'MCO',
  },
  {
    code: 'MN',
    name: 'Mongolia',
    three_letter_code: 'MNG',
  },
  {
    code: 'ME',
    name: 'Montenegro',
    three_letter_code: 'MNE',
  },
  {
    code: 'MS',
    name: 'Montserrat',
    three_letter_code: 'MSR',
  },
  {
    code: 'MA',
    name: 'Morocco',
    three_letter_code: 'MAR',
  },
  {
    code: 'MZ',
    name: 'Mozambique',
    three_letter_code: 'MOZ',
  },
  {
    code: 'NA',
    name: 'Namibia',
    three_letter_code: 'NAM',
  },
  {
    code: 'NR',
    name: 'Nauru',
    three_letter_code: 'NRU',
  },
  {
    code: 'NP',
    name: 'Nepal',
    three_letter_code: 'NPL',
  },
  {
    code: 'NL',
    name: 'Netherlands',
    three_letter_code: 'NLD',
  },
  {
    code: 'AN',
    name: 'Netherlands Antilles',
    three_letter_code: 'ANT',
  },
  {
    code: 'NC',
    name: 'New Caledonia',
    three_letter_code: 'NCL',
  },
  {
    code: 'NZ',
    name: 'New Zealand',
    three_letter_code: 'NZL',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
    three_letter_code: 'NIC',
  },
  {
    code: 'NE',
    name: 'Niger',
    three_letter_code: 'NER',
  },
  {
    code: 'NG',
    name: 'Nigeria',
    three_letter_code: 'NGA',
  },
  {
    code: 'NU',
    name: 'Niue',
    three_letter_code: 'NIU',
  },
  {
    code: 'MP',
    name: 'Northern Mariana Islands',
    three_letter_code: 'MNP',
  },
  {
    code: 'NO',
    name: 'Norway',
    three_letter_code: 'NOR',
  },
  {
    code: 'OM',
    name: 'Oman',
    three_letter_code: 'OMN',
  },
  {
    code: 'PK',
    name: 'Pakistan',
    three_letter_code: 'PAK',
  },
  {
    code: 'PW',
    name: 'Palau',
    three_letter_code: 'PLW',
  },
  {
    code: 'PA',
    name: 'Panama',
    three_letter_code: 'PAN',
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
    three_letter_code: 'PNG',
  },
  {
    code: 'PY',
    name: 'Paraguay',
    three_letter_code: 'PRY',
  },
  {
    code: 'PE',
    name: 'Peru',
    three_letter_code: 'PER',
  },
  {
    code: 'PH',
    name: 'Philippines',
    three_letter_code: 'PHL',
  },
  {
    code: 'PN',
    name: 'Pitcairn Islands',
    three_letter_code: 'PCN',
  },
  {
    code: 'PL',
    name: 'Poland',
    three_letter_code: 'POL',
  },
  {
    code: 'PT',
    name: 'Portugal',
    three_letter_code: 'PRT',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
    three_letter_code: 'PRI',
  },
  {
    code: 'QA',
    name: 'Qatar',
    three_letter_code: 'QAT',
  },
  {
    code: 'RE',
    name: 'Reunion Island',
    three_letter_code: 'REU',
  },
  {
    code: 'RO',
    name: 'Romania',
    three_letter_code: 'ROU',
  },
  {
    code: 'RU',
    name: 'Russia',
    three_letter_code: 'RUS',
  },
  {
    code: 'RW',
    name: 'Rwanda',
    three_letter_code: 'RWA',
  },
  {
    code: 'BL',
    name: 'Saint Barthélemy',
    three_letter_code: 'BLM',
  },
  {
    code: 'SH',
    name: 'Saint Helena',
    three_letter_code: 'SHN',
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
    three_letter_code: 'KNA',
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
    three_letter_code: 'LCA',
  },
  {
    code: 'MF',
    name: 'Saint Martin',
    three_letter_code: 'MAF',
  },
  {
    code: 'PM',
    name: 'Saint Pierre and Miquelon',
    three_letter_code: 'SPM',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and The Grenadines',
    three_letter_code: 'VCT',
  },
  {
    code: 'WS',
    name: 'Samoa',
    three_letter_code: 'WSM',
  },
  {
    code: 'SM',
    name: 'San Marino',
    three_letter_code: 'SMR',
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
    three_letter_code: 'STP',
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
    three_letter_code: 'SAU',
  },
  {
    code: 'SN',
    name: 'Senegal',
    three_letter_code: 'SEN',
  },
  {
    code: 'RS',
    name: 'Serbia',
    three_letter_code: 'SRB',
  },
  {
    code: 'SC',
    name: 'Seychelles',
    three_letter_code: 'SYC',
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
    three_letter_code: 'SLE',
  },
  {
    code: 'SG',
    name: 'Singapore',
    three_letter_code: 'SGP',
  },
  {
    code: 'SX',
    name: 'Sint Maarten',
    three_letter_code: 'SXM',
  },
  {
    code: 'SK',
    name: 'Slovakia ',
    three_letter_code: 'SVK',
  },
  {
    code: 'SI',
    name: 'Slovenia',
    three_letter_code: 'SVN',
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
    three_letter_code: 'SLB',
  },
  {
    code: 'ZA',
    name: 'South Africa',
    three_letter_code: 'ZAF',
  },
  {
    code: 'KR',
    name: 'South Korea',
    three_letter_code: 'KOR',
  },
  {
    code: 'ES',
    name: 'Spain',
    three_letter_code: 'ESP',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
    three_letter_code: 'LKA',
  },
  {
    code: 'SR',
    name: 'Suriname',
    three_letter_code: 'SUR',
  },
  {
    code: 'SZ',
    name: 'Swaziland',
    three_letter_code: 'SWZ',
  },
  {
    code: 'SE',
    name: 'Sweden',
    three_letter_code: 'SWE',
  },
  {
    code: 'CH',
    name: 'Switzerland',
    three_letter_code: 'CHE',
  },
  {
    code: 'TW',
    name: 'Taiwan',
    three_letter_code: 'TWN',
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
    three_letter_code: 'TJK',
  },
  {
    code: 'TZ',
    name: 'Tanzania',
    three_letter_code: 'TZA',
  },
  {
    code: 'TH',
    name: 'Thailand',
    three_letter_code: 'THA',
  },
  {
    code: 'TG',
    name: 'Togo',
    three_letter_code: 'TGO',
  },
  {
    code: 'TK',
    name: 'Tokelau',
    three_letter_code: 'TKL',
  },
  {
    code: 'TO',
    name: 'Tonga',
    three_letter_code: 'TON',
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
    three_letter_code: 'TTO',
  },
  {
    code: 'TN',
    name: 'Tunisia',
    three_letter_code: 'TUN',
  },
  {
    code: 'TR',
    name: 'Turkey',
    three_letter_code: 'TUR',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
    three_letter_code: 'TKM',
  },
  {
    code: 'TC',
    name: 'Turks and Caicos Islands',
    three_letter_code: 'TCA',
  },
  {
    code: 'TV',
    name: 'Tuvalu',
    three_letter_code: 'TUV',
  },
  {
    code: 'VI',
    name: 'U.S. Virgin Islands',
    three_letter_code: 'VIR',
  },
  {
    code: 'UG',
    name: 'Uganda',
    three_letter_code: 'UGA',
  },
  {
    code: 'UA',
    name: 'Ukraine',
    three_letter_code: 'UKR',
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
    three_letter_code: 'ARE',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
    three_letter_code: 'GBR',
  },
  {
    code: 'US',
    name: 'United States',
    three_letter_code: 'USA',
  },
  {
    code: 'UM',
    name: 'United States Minor Outlying Islands',
    three_letter_code: 'UMI',
  },
  {
    code: 'UY',
    name: 'Uruguay',
    three_letter_code: 'URY',
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
    three_letter_code: 'UZB',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
    three_letter_code: 'VUT',
  },
  {
    code: 'VA',
    name: 'Vatican City',
    three_letter_code: 'VAT',
  },
  {
    code: 'VE',
    name: 'Venezuela',
    three_letter_code: 'VEN',
  },
  {
    code: 'VN',
    name: 'Viet Nam',
    three_letter_code: 'VNM',
  },
  {
    code: 'WF',
    name: 'Wallis and Futuna Islands',
    three_letter_code: 'WLF',
  },
  {
    code: 'EH',
    name: 'Western Sahara',
    three_letter_code: 'ESH',
  },
  {
    code: 'YE',
    name: 'Yemen',
    three_letter_code: 'YEM',
  },
  {
    code: 'ZM',
    name: 'Zambia',
    three_letter_code: 'ZMB',
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
    three_letter_code: 'ZWE',
  },
];

export default massPayCountries;
